/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchRunResultArtifactsReportCsv
 */
export interface BatchRunResultArtifactsReportCsv {
    /**
     * batch service が成果物を PUT する先
     * @type {string}
     * @memberof BatchRunResultArtifactsReportCsv
     */
    s3ObjectPath: string;
    /**
     * ドキュメント番号（帳票/CSVのキー）
     * @type {string}
     * @memberof BatchRunResultArtifactsReportCsv
     */
    documentNo: string;
}

/**
 * Check if a given object implements the BatchRunResultArtifactsReportCsv interface.
 */
export function instanceOfBatchRunResultArtifactsReportCsv(value: object): value is BatchRunResultArtifactsReportCsv {
    if (!('s3ObjectPath' in value) || value['s3ObjectPath'] === undefined) return false;
    if (!('documentNo' in value) || value['documentNo'] === undefined) return false;
    return true;
}

export function BatchRunResultArtifactsReportCsvFromJSON(json: any): BatchRunResultArtifactsReportCsv {
    return BatchRunResultArtifactsReportCsvFromJSONTyped(json, false);
}

export function BatchRunResultArtifactsReportCsvFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchRunResultArtifactsReportCsv {
    if (json == null) {
        return json;
    }
    return {
        
        's3ObjectPath': json['s3_object_path'],
        'documentNo': json['document_no'],
    };
}

export function BatchRunResultArtifactsReportCsvToJSON(json: any): BatchRunResultArtifactsReportCsv {
    return BatchRunResultArtifactsReportCsvToJSONTyped(json, false);
}

export function BatchRunResultArtifactsReportCsvToJSONTyped(value?: BatchRunResultArtifactsReportCsv | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        's3_object_path': value['s3ObjectPath'],
        'document_no': value['documentNo'],
    };
}

